import { gql } from '@apollo/client';
import { intersection } from 'ramda';
import { HasAccessToDisplayPageFragment } from '../generated/types';
import { useUserGroups } from './useUserGroups';

export const HAS_ACCESS_TO_DISPLAY_PAGE_FRAGMENT = gql`
  fragment HasAccessToDisplayPageFragment on DisplayPage {
    restrictedToUserGroups: restricted_to_user_groups
  }
`;

const NO_RESTRICTION_RULES = {
  restrictedToUserGroups: [] as number[]
};

export const useHasAccessToDisplayPage = (rules?: HasAccessToDisplayPageFragment | null) => {
  const { restrictedToUserGroups } = rules ?? NO_RESTRICTION_RULES;

  const { userGroups, loading } = useUserGroups({
    skip: restrictedToUserGroups.length === 0
  });

  return {
    hasAccess:
      restrictedToUserGroups.length === 0 ||
      intersection(restrictedToUserGroups, userGroups).length > 0,
    loading
  };
};
